import { CaretDown, CaretUp } from '@phosphor-icons/react';

interface PlaidInfoSectionProps {
  isExpanded: boolean;
  onToggle: () => void;
}

function PlaidInfoSection({ isExpanded, onToggle }: PlaidInfoSectionProps) {
  return (
    <div className="w-full">
      {/* Toggle button */}
      <button
        onClick={onToggle}
        className="flex w-full items-center justify-center space-x-2 text-base text-primary transition-opacity hover:opacity-80"
        aria-expanded={isExpanded}
        aria-controls="plaid-info-content"
      >
        <span>What is Plaid?</span>
        {isExpanded ? (
          <CaretUp size={20} className="text-primary" />
        ) : (
          <CaretDown size={20} className="text-primary" />
        )}
      </button>

      {/* Collapsible content */}
      <div
        id="plaid-info-content"
        className={`overflow-hidden transition-all duration-300 ease-in-out ${
          isExpanded ? 'max-h-auto opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="mt-4 rounded-lg bg-gray-50 p-4">
          <p className="text-sm text-gray-700">
            Plaid is a financial infrastructure platform that enables
            applications like TACH to securely connect with users' bank
            accounts. It supports integrations with over 11,000 financial
            institutions across the U.S., Canada, and Europe, offering deep,
            authenticated access to transaction histories, account balances, and
            other financial data. <br />
            <br /> In TACH's case, we use Plaid to pull bank statements and
            transaction data in order to verify business revenue and better
            inform cash flow forecasts and budgeting. Bank credentials are never
            shared with TACH directly, and Plaid ensures that credentials are
            never shared with third parties. Plaid uses industry-standard
            encryption (AES-256 and TLS) and multi-factor authentication to
            protect user data.
          </p>
          <a
            href="https://plaid.com/what-is-plaid/"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-2 inline-block text-sm text-primary underline hover:opacity-80"
          >
            Learn more about Plaid here
          </a>
        </div>
      </div>
    </div>
  );
}

export default PlaidInfoSection;
